import { defineStore } from 'pinia';

export interface ILoaderState {
  show?: boolean;
  message?: string;
  delay?: number;
  manual?: boolean;
}

export const useLoaderStore = defineStore('loader', {
  state: (): ILoaderState => ({
    show: false,
    message: '',
    delay: 0,
    manual: false,
  }),

  getters: {
    loader: (state) => state,
  },

  actions: {
    setLoader({
      show = false,
      message = 'Пожалуйста, подождите. Идёт загрузка.',
      delay = 1800,
      manual = false,
    }: ILoaderState = {}) {
      this.show = show;
      this.message = message;
      this.delay = delay;
      this.manual = manual;

      if (show && !manual) {
        setTimeout(() => {
          this.show = false;
          this.message = '';
          this.delay = 0;
          this.manual = false;
          console.log('Лоадер закрылся автоматически');
        }, delay);
      }
    },
  },
});

export default useLoaderStore;
